import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    props: {
        itemClass: {
            type: String,
            default: "",
        },
        item: {
            type: Object,
            default: () => {
                return {};
            },
        },
        headers: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isFirstFutureItem: {
            type: Boolean,
            default: false,
        },
    },
})
export default class DraggableTableRowHandler extends Vue {
    itemClass!: any;
    isFirstFutureItem!: boolean;

    get getClass(): any {
        let classes = this.itemClass;

        if (this.isFirstFutureItem) {
            classes += ' separator-top';
        }
        return classes;
    };

    columnName(header: any) {
        return `item.${header.value}`;
    };

    getAlignment(header: any) {
        const align = header.align ? header.align : "right";
        return `text-align: ${align}`;
    };

    getNonSlotValue(item: any, header: any) {
        const val = item[header.value];

        if (val) {
            return val;
        }

        return "";
    };
};
